// src/utils/game-manager.js
export class GameManager {
    constructor() {
        this.iframe = null;
        this.isGameActive = false;
        this.container = null;
    }

    // Load game in a controlled manner
    loadGame(url, containerElement) {
        return new Promise((resolve, reject) => {
            try {
                this.container = containerElement;

                // Create iframe with strict sandboxing
                this.iframe = document.createElement('iframe');
                this.iframe.src = url;
                this.iframe.sandbox = 'allow-scripts allow-same-origin';
                this.iframe.style.width = '100%';
                this.iframe.style.height = '70vh';
                this.iframe.style.aspectRatio = '16/9';
                this.iframe.style.border = 'none';
                this.iframe.loading = 'lazy';
                this.iframe.allowFullscreen = true;

                // Add load event listener
                this.iframe.addEventListener('load', () => {
                    this.isGameActive = true;
                    console.log('Game loaded successfully');
                    resolve();
                });

                // Add error handling
                this.iframe.addEventListener('error', (error) => {
                    this.isGameActive = false;
                    console.error('Game loading failed:', error);
                    reject(error);
                });

                // Clear container and append iframe
                if (containerElement) {
                    containerElement.innerHTML = '';
                    containerElement.appendChild(this.iframe);
                } else {
                    reject(new Error('Container element not found'));
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    // Pause game when not visible
    pauseGame() {
        if (this.iframe && this.iframe.contentWindow) {
            try {
                // Try to post message to pause the game
                this.iframe.contentWindow.postMessage({
                    action: 'pause'
                }, '*');
                console.log('Game paused');
            } catch (e) {
                // If we can't communicate, reduce visibility
                this.iframe.style.opacity = '0.5';
                this.iframe.style.pointerEvents = 'none';
            }
        }
    }

    // Resume game
    resumeGame() {
        if (this.iframe) {
            this.iframe.style.opacity = '1';
            this.iframe.style.pointerEvents = 'auto';
            try {
                this.iframe.contentWindow.postMessage({
                    action: 'resume'
                }, '*');
                console.log('Game resumed');
            } catch (e) {
                // Ignore if game doesn't support messaging
            }
        }
    }

    // Toggle fullscreen
    toggleFullscreen() {
        if (!this.iframe) return;

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (isIOS) {
            this.handleIOSFullscreen();
        } else {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                this.iframe.requestFullscreen();
            }
        }
    }

    handleIOSFullscreen() {
        if (!this.iframe) return;

        if (!this.iframe.classList.contains("ios-fullscreen")) {
            this.iframe.classList.add("ios-fullscreen");
        } else {
            this.iframe.classList.remove("ios-fullscreen");
        }
    }

    // Exit iOS fullscreen
    exitIOSFullscreen() {
        if (this.iframe && this.iframe.classList.contains("ios-fullscreen")) {
            this.iframe.classList.remove("ios-fullscreen");
        }
    }

    // Clean up
    destroy() {
        if (this.iframe) {
            // Exit fullscreen first
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }
            this.exitIOSFullscreen();

            // Remove iframe from DOM
            this.iframe.remove();
            this.iframe = null;
        }
        this.isGameActive = false;
        this.container = null;
    }

    // Get current iframe element
    getIframe() {
        return this.iframe;
    }
}